import React, { Component } from "react";
import Header from "../Layouts/Header";
import Footer from "../Layouts/Footer";
import Breadcrumb from "../Layouts/Breadcrumb";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import ls from "local-storage";
import { Dialog, DialogTitle, DialogContent, Typography, Button, CircularProgress, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import AuthApi from "../Services/Authapi";
import { Birthdatecard } from "./BirthdateCard";
import { LoginBirthdateCard } from "./LoginBirthdateCard";
import CloseIcon from "@material-ui/icons/Close";
import Tableforfilter from "./Filter/Tableforfilter";
import "./Dashboard.css";
import AuthCheckComponent from "../Layouts/Token";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import { createSwalLoaderNode } from "../Layouts/swalLoader";
import DragAndDropSections from "./DashboardDragDropContext";
import EmployeePresenceMap from "./EmployeePresenceMap";
import moment from "moment";
import "./Leaves/Leave.css";
import DashboardCalendar from "./DashboardCalendar";
import ReminderPopup from "./ReminderPopup/ReminderPopup";

let bdayID = false;
const HOLIDAY_DATE_FORMATS = ["DD-MM-YYYY", "YYYY-MM-DD", "MM-DD-YYYY"];
const DASHBOARD_HIDDEN_CALENDAR_ITEMS_KEY = "dashboardHiddenCalendarItems";
const DASHBOARD_UPDATED_CALENDAR_ITEMS_KEY = "dashboardUpdatedCalendarItems";
const DASHBOARD_CREATED_CALENDAR_ITEMS_KEY = "dashboardCreatedCalendarItems";

const getEventOwnerId = (event = {}) => (
  event.user_id ??
  event.userId ??
  event.UserId ??
  event.created_by ??
  event.createdBy ??
  event.employee_id ??
  event.employeeId ??
  event.author_id ??
  event.authorId ??
  null
);

const getEventShowToAll = (event = {}) => {
  const rawValue = event.showToAll ?? event.show_to_all ?? event.ShowToAll ?? event.show_all;

  if (typeof rawValue === "undefined" || rawValue === null || rawValue === "") {
    return null;
  }

  if (typeof rawValue === "boolean") {
    return rawValue;
  }

  if (typeof rawValue === "number") {
    return rawValue === 1;
  }

  const normalizedValue = String(rawValue).trim().toLowerCase();
  if (["1", "true", "yes"].includes(normalizedValue)) {
    return true;
  }

  if (["0", "false", "no"].includes(normalizedValue)) {
    return false;
  }

  return null;
};

const getDashboardCalendarEventTitle = (event = {}) => (
  event.Subject ||
  event.title ||
  event.name ||
  event.eventName ||
  event.upcomingEventName ||
  ""
);

const getDashboardCalendarComparableCategory = (event = {}, fallbackCategory = "") => {
  const rawCategory = String(event.Category || event.category || fallbackCategory || "").trim().toLowerCase();
  return rawCategory === "reminder" ? "calendar" : rawCategory;
};

const getDashboardCalendarComparableId = (event = {}) => {
  const rawId = event.calendar_event_id ?? event.calendarEventId ?? event.event_id ?? event.eventId ?? event.Id ?? event.id ?? null;

  if (rawId === null || typeof rawId === "undefined") {
    return "";
  }

  return String(rawId).trim();
};

const normalizeDashboardCalendarComparableDate = (value) => {
  if (!value) {
    return "";
  }

  const normalizedMoment = moment(value);
  if (normalizedMoment.isValid()) {
    return normalizedMoment.toISOString();
  }

  return String(value).trim();
};

const getDashboardCalendarComparableKey = (event = {}) => {
  const category = getDashboardCalendarComparableCategory(event);
  const explicitId = getDashboardCalendarComparableId(event);
  const title = String(getDashboardCalendarEventTitle(event)).trim().toLowerCase();
  const start = normalizeDashboardCalendarComparableDate(event.StartTime || event.start || event.date || "");
  const end = normalizeDashboardCalendarComparableDate(event.EndTime || event.end || event.date || "");

  if (explicitId) {
    return [category || "item", explicitId].join("|");
  }

  return [
    category || "item",
    title || "untitled",
    start || "no-start",
    end || "no-end",
  ].join("|");
};

const isApprovedLeaveEvent = (event = {}, isAdminCalendarUser = false) => {
  return true;
};

const filterDashboardCalendarEvents = (events = [], currentUserId, isAdminCalendarUser) => {
  return events.filter((event) => {

    const category = String(event.Category || event.category || "").toLowerCase();
    if (category === "birthday" || category === "bday") {
      return true;
    }

    if (category === "leave") {
      if (isAdminCalendarUser) {
        return true;
      }
      const ownerId = getEventOwnerId(event);
      if (ownerId !== null && typeof currentUserId !== "undefined" && currentUserId !== null) {
        return String(ownerId) === String(currentUserId);
      }
      return true;
    }

    const visibility = getEventShowToAll(event);

    if (visibility === null) {
      return true;
    }

    if (visibility === true) {
      return true;
    }

    const ownerId = getEventOwnerId(event);
    if (ownerId !== null && typeof currentUserId !== "undefined" && currentUserId !== null) {
      if (String(ownerId) === String(currentUserId)) {
        return true;
      }
    }

    if (typeof currentUserId !== "undefined" && currentUserId !== null) {
      const rawTargetUsers = event.target_user_ids || event.TargetUserIds || event.targetUserIds || [];
      let parsedIds = [];
      if (Array.isArray(rawTargetUsers)) {
        parsedIds = rawTargetUsers.map(id => String(id));
      } else if (typeof rawTargetUsers === 'string') {
        try {
          parsedIds = JSON.parse(rawTargetUsers).map(id => String(id));
        } catch (e) {
          parsedIds = rawTargetUsers.split(',').map(id => id.trim()).filter(Boolean);
        }
      }
      if (parsedIds.includes(String(currentUserId))) {
        return true;
      }
    }

    return false;
  });
};

const getDashboardCalendarEventStorageKey = (event = {}, fallbackId = null, eventMeta = {}) => {
  const category = String(event.Category || event.category || eventMeta.category || "").trim().toLowerCase();
  const title = String(getDashboardCalendarEventTitle(event)).trim().toLowerCase();
  const start = String(event.StartTime || event.start || event.date || "").trim();
  const end = String(event.EndTime || event.end || event.date || "").trim();
  const explicitId = event.calendar_event_id ?? event.calendarEventId ?? event.event_id ?? event.eventId ?? event.Id ?? event.id ?? fallbackId ?? "";

  return [
    category || "item",
    explicitId || "no-id",
    title || "untitled",
    start || "no-start",
    end || "no-end",
  ].join("|");
};

const getDashboardCalendarEventPersistenceKey = (event = {}, fallbackId = null, eventMeta = {}) => {
  const category = String(event.Category || event.category || eventMeta.category || "").trim().toLowerCase();
  const explicitId = event.calendar_event_id ?? event.calendarEventId ?? event.event_id ?? event.eventId ?? event.Id ?? event.id ?? fallbackId ?? "";
  const start = String(event.StartTime || event.start || event.date || "").trim();

  return [
    category || "item",
    explicitId || "no-id",
    start || "no-start",
  ].join("|");
};

const getHiddenDashboardCalendarItems = () => {
  try {
    const storedItems = ls.get(DASHBOARD_HIDDEN_CALENDAR_ITEMS_KEY);
    return Array.isArray(storedItems) ? storedItems : [];
  } catch (error) {
    return [];
  }
};

const setHiddenDashboardCalendarItems = (items = []) => {
  try {
    ls.set(DASHBOARD_HIDDEN_CALENDAR_ITEMS_KEY, items);
  } catch (error) {
    // Ignore local persistence failures and keep UI responsive.
  }
};

const getUpdatedDashboardCalendarItems = () => {
  try {
    const storedItems = ls.get(DASHBOARD_UPDATED_CALENDAR_ITEMS_KEY);
    return storedItems && typeof storedItems === "object" ? storedItems : {};
  } catch (error) {
    return {};
  }
};

const setUpdatedDashboardCalendarItems = (items = {}) => {
  try {
    ls.set(DASHBOARD_UPDATED_CALENDAR_ITEMS_KEY, items);
  } catch (error) {
    // Ignore local persistence failures and keep UI responsive.
  }
};

const getCreatedDashboardCalendarItems = () => {
  try {
    const storedItems = ls.get(DASHBOARD_CREATED_CALENDAR_ITEMS_KEY);
    return Array.isArray(storedItems) ? storedItems : [];
  } catch (error) {
    return [];
  }
};

const setCreatedDashboardCalendarItems = (items = []) => {
  try {
    ls.set(DASHBOARD_CREATED_CALENDAR_ITEMS_KEY, items);
  } catch (error) {
    // Ignore local persistence failures and keep UI responsive.
  }
};

const isSameDashboardCalendarEvent = (firstEvent = {}, secondEvent = {}) => {
  return getDashboardCalendarComparableKey(firstEvent) === getDashboardCalendarComparableKey(secondEvent);
};

const styles = (theme) => ({
  congratsDialog: {
    padding: "10px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    backgroundColor: "#f0f8ff",
    position: "relative",
    textAlign: "center",
    width: "350px",
  },
  congratsTitle: {
    padding: "5px 0",
    backgroundColor: "#1B6E95",
    color: "#fff",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    fontSize: "1.5em",
  },
  congratsContent: {
    padding: "20px",
  },
  congratsText: {
    fontSize: "1.2em",
    color: "#333",
    marginBottom: "20px",
  },
  congratsCloseIcon: {
    position: "absolute",
    top: 19,
    right: 19,
    cursor: "pointer",
    color: "#fff",
    backgroundColor: "#f44336",
    borderRadius: "50%",
    padding: "2px",
  },
  congratsImage: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    marginBottom: "10px",
  },
  newJoined: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    marginBottom: "3%",
  },
  upcomingCard: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    marginBottom: "3%",
  },
  pendingLeavesCard: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    marginBottom: "3%",
  },
  holidayLeavesCard: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    marginBottom: "3%",
  },
  pendingLeavesHeader: {
    backgroundColor: "transparent",
    color: "#1b6e95",
    padding: "15px",
    textAlign: "left",
  },
  tableHeader: {
    backgroundColor: "#1b6e95",
  },
  tableCell: {
    color: "#333",
  },
  pendingLeavesTable: {
    width: "100%",
  },
  pendingLeavesTableCell: {
    padding: "14px 10px",
    borderBottom: "1px solid #ddd",
    fontSize: "12px",
  },
  pendingLeavesTableHeaderCell: {
    padding: "12px 10px",
    backgroundColor: "#036dda",
    fontWeight: "bold",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
  },
  zebraRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f5f5",
    },
    "&:hover": {
      backgroundColor: "rgba(3, 109, 218, 0.15) !important",
    },
  },
});

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.dashboardCalendarRangeCache = new Map();
    this.pendingDashboardCalendarRangeKey = null;
    this.state = {
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      alertIsOpen: false,
      page: 0,
      rowsPerPage: 10,
      rows: [],
      totalDurationTime: "",
      birthdayApiCalled: false,
      selectedDate: "",
      getData: [],
      userleave: [],
      current: 0,
      people: [],
      userID: false,
      show: true,
      activeStep: 0,
      activeStep1: 0,
      openEventModal: false,
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      alertIsOpen: false,
      page: 0,
      rowsPerPage: 10,
      rows: [],
      totalDurationTime: "",
      birthdayApiCalled: false,
      selectedDate: "",
      getData: [],
      userleave: [],
      current: 0,
      people: [],
      userID: false,
      show: true,
      activeStep: 0,
      activeStep1: 0,
      openEventModal: false,
      showFullDescription: false,
      eventDetails: null,
      congratsEmployee: null,
      congratsEmployees: [], // Array to store all employees with same DOJ
      currentCongratsIndex: 0, // Track current employee being shown
      pendingLeaves: [],
      dialogShown: localStorage.getItem("dialogShown") === "true",
      approvedLeaves: [],
      allUsers: [],
      upcomingHolidays: [],
      timeEntries: { status: false, code: null, data: [] },
      usersWithCurrentMonthDOJ: [],
      congratsPopupShown: false,
      showLeaveDetailsPopup: false,
      selectedLeaveDetails: null,
      loading: false,
      calendarLoading: false,
      dashboardCalendarEvents: [],
      sections: [],
      isReasonExpanded: false,
      statusColors: {},
    };
  }
  componentWillMount() {
    if (this.props && this.props.authToken === false) {

      // this.props.history.push("/login");
    }
  }

  // componentWillReceiveProps(props) {
  //   if (props && props.authToken === false) {
  //     // Remove or comment out the redirection logic
  //     // this.props.history.push("/login");
  //   }
  // }
  componentWillReceiveProps(props) {
    // Avoid redirecting to login on arbitrary prop changes; let route guards handle auth
  }

  componentDidMount() {
    AuthApi.getStatusColors().then((response) => {
      if (response && response.status && response.data) {
        const fetchedColors = response.data;
        // Default colors to ensure visibility in dark mode (where API might return white for text)
        const defaultColors = {
          'Present': '#1dbb11',
          'Absent': '#ff5c5c',
          'Half day': '#0acdb6',
          'Left Early': '#065112',
          'Late': '#9d744d',
          'Week Off': '#036dda',
          'Weekend Present': '#ff8c42',
          'Holiday': '#ca04cd',
          'Comes Late': '#9d744d',
          'Short Hours': '#ffffff'
        };

        Object.keys(defaultColors).forEach(key => {
          if (!fetchedColors[key] || (typeof fetchedColors[key] === 'string' && (fetchedColors[key].toLowerCase() === '#ffffff' || fetchedColors[key].toLowerCase() === '#fff'))) {
            fetchedColors[key] = defaultColors[key];
          }
        });

        if (fetchedColors['Comes Late'] && !fetchedColors['Late']) {
          fetchedColors['Late'] = fetchedColors['Comes Late'];
        }

        this.setState({ statusColors: fetchedColors });
      } else {
        this.setState({ statusColors: {} });
      }
    });
    this.fetchSectionsOrderFromDatabase();
    this.getEventData();
    this.notificationForBday();
    this.fetchAllUsers();
    this.handleClickOpen();
    this.getPendingLeaves();
    this.getUpcomingHolidays();
    this.getTimeEntries();
    this.userleave1();
    this.getUsersWithCurrentMonthDOJ();
    this.getDashboardCalendarEvents();

    const { location } = this.props;
    if (
      location.state &&
      location.state.eventId &&
      sessionStorage.getItem("openEventModal") === "true"
    ) {
      this.fetchEventDetails(location.state.eventId);
      sessionStorage.removeItem("openEventModal");
    }

    // Check if congrats popup was shown for today
    const today = new Date().toDateString();
    const lastCongratsDate = localStorage.getItem("lastCongratsDate");

    if (lastCongratsDate === today) {
      this.setState({ congratsPopupShown: true });
    } else {
      this.setState({ congratsPopupShown: false });
      localStorage.setItem("lastCongratsDate", today);
    }
  }

  fetchSectionsOrderFromDatabase = async () => {
    try {
      const userId = ls.get('user').id;
      const response = await AuthApi.getSectionsOrder(userId);
      const defaultSections = [
        { id: 'Upcomingevent' },
        { id: 'bfffday' },
        { id: 'pendingLeaves' },
        { id: 'upcomingHolidays' },
        { id: 'timeEntries' },
        { id: 'userleave' },
        { id: 'newJoinedEmployees' },
        { id: 'attendanceChart' },
      ];

      if (response && response.status === true) {
        let fetchedSections = response.sections;
        // Ensure uniqueness of fetched sections
        fetchedSections = fetchedSections.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);

        const extraSections = defaultSections.filter(
          (section) => !fetchedSections.some((fetched) => fetched.id === section.id)
        );

        if (extraSections.length > 0) {
          const updatedSections = [...fetchedSections, ...extraSections];
          this.setState({ sections: updatedSections });
          this.saveSectionsOrderToDatabase(updatedSections);
        } else {
          this.setState({ sections: fetchedSections });
        }
      } else {
        this.setState({ sections: defaultSections });
        this.saveSectionsOrderToDatabase(defaultSections);
      }
    } catch (error) {
      console.error("Error fetching sections order:", error);
    }
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const sections = Array.from(this.state.sections);
    const {
      getData: active,
      people: active1,
      pendingLeaves,
      approvedLeaves,
      upcomingHolidays,
      timeEntries,
      userleave,
      usersWithCurrentMonthDOJ,
    } = this.state;

    const permissionsRaw = this.props.authUser ? this.props.authUser.userAccess : [];
    const permissionsArray = Array.isArray(permissionsRaw) ? permissionsRaw : [];
    const isSuperAdmin = ls("roles") === "Super Admin";

    const filteredSections = sections.filter((section) => {
      if (section.id === 'Upcomingevent') return permissionsArray.includes("Dashboard.Upcomingevent") && active.length > 0;
      if (section.id === 'bfffday') return permissionsArray.includes("Dashboard.Birthday") && active1.length > 0;
      if (section.id === 'pendingLeaves') return pendingLeaves.length > 0 || approvedLeaves.length > 0;
      if (section.id === 'upcomingHolidays') return upcomingHolidays.length > 0;
      if (section.id === 'timeEntries') return isSuperAdmin && timeEntries && timeEntries.data && timeEntries.data.length > 0;
      if (section.id === 'userleave') return isSuperAdmin && userleave.length > 0;
      if (section.id === 'newJoinedEmployees') return isSuperAdmin && usersWithCurrentMonthDOJ.length > 0;
      if (section.id === 'attendanceChart') return isSuperAdmin;
      return false;
    });

    const [reorderedItem] = filteredSections.splice(result.source.index, 1);
    filteredSections.splice(result.destination.index, 0, reorderedItem);

    const filteredIdSet = new Set(filteredSections.map((s) => s.id));
    const newFiltered = [...filteredSections];
    const rebuilt = sections.map((s) => (filteredIdSet.has(s.id) ? newFiltered.shift() : s));

    this.setState({ sections: rebuilt }, async () => {
      const userId = ls.get('user').id;
      const response = await AuthApi.getSectionsOrder(userId);

      if (response && response.status === true) {
        const fetchedSections = response.sections;
        const extraSections = rebuilt.filter(
          (section) => !fetchedSections.some((fetched) => fetched.id === section.id)
        );

        if (extraSections.length > 0 || JSON.stringify(rebuilt) !== JSON.stringify(fetchedSections)) {
          this.saveSectionsOrderToDatabase(rebuilt);
        }
      } else {
        this.saveSectionsOrderToDatabase(rebuilt);
      }
    });
  };

  saveSectionsOrderToDatabase = async (sections) => {
    try {
      await AuthApi.saveSectionsOrder({ sections });
    } catch (error) {
      console.error("Error saving sections order:", error);
    }
  };

  async getEventData() {
    const EventData = await AuthApi.getAllEvents();
    if (EventData && EventData.status === true) {
      this.setState({
        getData: EventData.data,
      });
    }
  }

  async fetchEventDetails(eventId) {
    const allEvents = await AuthApi.getAllEvents();
    if (allEvents && allEvents.status === true) {
      const eventDetails = allEvents.data.find((event) => event.id === eventId);
      if (eventDetails) {
        this.setState({
          eventDetails: eventDetails,
          openEventModal: true,
        });
      }
    }
  }

  getDashboardCalendarRangeKey = (start, end) => (
    `${moment(start).format("YYYY-MM-DD")}|${moment(end).format("YYYY-MM-DD")}`
  );

  generateUserBirthdayEvents = (start, end) => {
    const allUsers = this.state.allUsers || [];
    const people = this.state.people || [];

    const startMoment = start ? moment(start) : moment().startOf("month");
    const endMoment = end ? moment(end) : moment().endOf("month");
    const startYear = startMoment.year() - 1;
    const endYear = endMoment.year() + 1;

    const birthdayEvents = [];
    const processedUserKeys = new Set();

    const processUser = (user) => {
      const rawDob = user.dob || user.birthdate || user.date_of_birth || user.bday;
      if (!rawDob) return;

      const dobMoment = moment(rawDob, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY/MM/DD", "DD/MM/YYYY"], true).isValid()
        ? moment(rawDob, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY/MM/DD", "DD/MM/YYYY"])
        : moment(rawDob);

      if (!dobMoment.isValid()) return;

      const dobMonth = dobMoment.month();
      const dobDate = dobMoment.date();

      const firstName = (user.firstName || user.first_name || "").trim();
      const lastName = (user.lastName || user.last_name || "").trim();
      let userName = `${firstName} ${lastName}`.trim() || user.name || user.username || "User";
      
      const userUniqueKey = user.id || user.user_id || userName.toLowerCase();
      if (processedUserKeys.has(userUniqueKey)) return;
      processedUserKeys.add(userUniqueKey);

      for (let year = startYear; year <= endYear; year++) {
        const bdayMoment = moment({ year, month: dobMonth, day: dobDate });
        if (!bdayMoment.isValid()) continue;

        const dateStr = bdayMoment.format("YYYY-MM-DD");
        birthdayEvents.push({
          id: `birthday-user-${userUniqueKey}-${year}`,
          calendar_event_id: `bday-${userUniqueKey}-${year}`,
          Subject: `Birthday - ${userName}`,
          title: `Birthday - ${userName}`,
          Category: "birthday",
          category: "birthday",
          StartTime: `${dateStr} 00:00:00`,
          EndTime: `${dateStr} 23:59:59`,
          start: dateStr,
          end: dateStr,
          IsAllDay: 1,
          isAllDay: true,
          is_all_day: true,
          showToAll: true,
          show_to_all: true,
          user_id: user.id || user.user_id,
          userName: userName,
          isBirthdayEvent: true,
        });
      }
    };

    allUsers.forEach(processUser);
    people.forEach(processUser);

    return birthdayEvents;
  };

  buildDashboardCalendarVisibleEvents = (rawEvents = [], currentUserId, isAdminCalendarUser) => {
    const updatedItems = getUpdatedDashboardCalendarItems();
    const bdayEvents = this.generateUserBirthdayEvents(this.state.calendarVisibleStart, this.state.calendarVisibleEnd);
    const combinedRawEvents = [...rawEvents, ...bdayEvents];

    const mergedEvents = combinedRawEvents.map((event) => {
      const persistenceKey = getDashboardCalendarEventPersistenceKey(event);
      const override = updatedItems[persistenceKey];

      if (!override) {
        return event;
      }

      return {
        ...event,
        ...override,
      };
    });

    const dedupedEvents = [];
    const seenComparableKeys = new Set();

    mergedEvents.forEach((event) => {
      const comparableKey = getDashboardCalendarComparableKey(event);
      if (seenComparableKeys.has(comparableKey)) {
        return;
      }

      seenComparableKeys.add(comparableKey);
      dedupedEvents.push(event);
    });

    const hiddenItems = getHiddenDashboardCalendarItems();
    return filterDashboardCalendarEvents(dedupedEvents, currentUserId, isAdminCalendarUser).filter((event) => {
      const storageKey = getDashboardCalendarEventStorageKey(event);
      return !hiddenItems.includes(storageKey);
    });
  };

  getDashboardCalendarEvents = async (rangeStart, rangeEnd) => {
    const currentRole = ls("roles");
    const isAdminCalendarUser = currentRole === "Super Admin" || currentRole === "Admin";
    const currentUser = ls("user");
    const currentUserId = currentUser ? currentUser.id : null;
    const visibleDate = new Date();
    const start = rangeStart || this.state.calendarVisibleStart || new Date(visibleDate.getFullYear(), visibleDate.getMonth(), 1);
    const end = rangeEnd || this.state.calendarVisibleEnd || new Date(visibleDate.getFullYear(), visibleDate.getMonth() + 1, 0);
    const rangeKey = this.getDashboardCalendarRangeKey(start, end);
    const cachedRawEvents = this.dashboardCalendarRangeCache.get(rangeKey);

    if (cachedRawEvents) {
      this.setState({
        calendarVisibleStart: start,
        calendarVisibleEnd: end,
        dashboardCalendarEvents: this.buildDashboardCalendarVisibleEvents(cachedRawEvents, currentUserId, isAdminCalendarUser),
        calendarLoading: false,
      });
      return;
    }

    if (this.pendingDashboardCalendarRangeKey === rangeKey) {
      return;
    }

    this.pendingDashboardCalendarRangeKey = rangeKey;
    this.setState({
      calendarVisibleStart: start,
      calendarVisibleEnd: end,
      calendarLoading: true,
    });

    try {
      const response = await AuthApi.getDashboardCalendar({
        start: moment(start).format("YYYY-MM-DD"),
        end: moment(end).format("YYYY-MM-DD"),
      });

      if (this.pendingDashboardCalendarRangeKey !== rangeKey) {
        return;
      }

      if (response && response.status === true && response.data) {
        const rawEvents = Array.isArray(response.data.events) ? response.data.events : [];
        const currentCreatedItems = getCreatedDashboardCalendarItems();
        const unresolvedCreatedItems = currentCreatedItems.filter((createdItem) => {
          return !rawEvents.some((rawEvent) => isSameDashboardCalendarEvent(rawEvent, createdItem));
        });

        if (unresolvedCreatedItems.length !== currentCreatedItems.length) {
          setCreatedDashboardCalendarItems(unresolvedCreatedItems);
        }

        this.dashboardCalendarRangeCache.set(rangeKey, rawEvents);

        this.setState({
          dashboardCalendarEvents: this.buildDashboardCalendarVisibleEvents(rawEvents, currentUserId, isAdminCalendarUser),
        });
      } else {
        this.dashboardCalendarRangeCache.delete(rangeKey);
        this.setState({ dashboardCalendarEvents: [] });
      }
    } catch (error) {
      if (this.pendingDashboardCalendarRangeKey !== rangeKey) {
        return;
      }

      console.error("Error fetching dashboard calendar events:", error);
      this.dashboardCalendarRangeCache.delete(rangeKey);
      this.setState({ dashboardCalendarEvents: [] });
    } finally {
      if (this.pendingDashboardCalendarRangeKey === rangeKey) {
        this.pendingDashboardCalendarRangeKey = null;
        this.setState({ calendarLoading: false });
      }
    }
  };

  handleCalendarApplyLeave = (startDate, endDate, title) => {
    const startMoment = moment(startDate);
    const rawEndMoment = endDate ? moment(endDate) : moment(startDate);
    const hasSingleDaySelection = !endDate || rawEndMoment.diff(startMoment, "days") <= 1;
    const normalizedStart = startMoment.format("YYYY-MM-DD");
    const normalizedEnd = hasSingleDaySelection
      ? normalizedStart
      : rawEndMoment.clone().subtract(1, "day").format("YYYY-MM-DD");

    this.props.history.push({
      pathname: "/leave-tickets/add",
      state: {
        date: normalizedStart,
        endDate: normalizedEnd,
        message: title || "",
      },
    });
  };

  handleCalendarSaveQuickLeave = async (startDate, endDate, title, description = "", allDay = true, showToAll = false, targetUserIds = [], tabName = "") => {
    const startMoment = moment(startDate);
    const rawEndMoment = endDate ? moment(endDate) : moment(startDate);
    const hasSingleDaySelection = !endDate || rawEndMoment.diff(startMoment, "days") <= 1;
    const timeFormat = allDay ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss";

    const normalizedStart = startMoment.format(timeFormat);
    const normalizedEnd = hasSingleDaySelection
      ? (allDay ? normalizedStart : rawEndMoment.format(timeFormat))
      : (allDay
          ? rawEndMoment.clone().subtract(1, "day").format(timeFormat)
          : rawEndMoment.format(timeFormat));

    const eventPayload = {
      title: title,
      description: description,
      startDate: normalizedStart,
      endDate: normalizedEnd,
      isAllDay: allDay ? 1 : 0,
      showToAll: showToAll ? 1 : 0,
      targetUserIds: targetUserIds,
      category: tabName === "meeting" ? "meeting" : undefined,
    };

    swal({
      title: "Saving...",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode ? createSwalLoaderNode() : undefined,
    });

    try {
      let response = await AuthApi.createCalendarEvent(eventPayload);
      swal.close();
      if (response && response.status === true) {
        const currentCreatedItems = getCreatedDashboardCalendarItems();
        const nextCreatedItems = currentCreatedItems.filter((item) => {
          const itemTitle = String(getDashboardCalendarEventTitle(item)).trim().toLowerCase();
          const itemStart = String(item.StartTime || item.start || item.date || "").split(" ")[0];
          const itemEnd = String(item.EndTime || item.end || item.date || "").split(" ")[0];

          return !(
            itemTitle === String(title || "").trim().toLowerCase() &&
            itemStart === String(normalizedStart || "").split(" ")[0] &&
            itemEnd === String(normalizedEnd || "").split(" ")[0]
          );
        });

        setCreatedDashboardCalendarItems(nextCreatedItems);
        swal("Success", `"${title}" saved successfully!`, "success");
        this.dashboardCalendarRangeCache.clear();
        this.getDashboardCalendarEvents();
        return true;
      } else {
        const errorMsg = typeof response === "string" ? response : (response && response.message ? response.message : "An error occurred, Please try again later!");
        swal("Error", errorMsg, "error");
        return false;
      }
    } catch (error) {
      swal("Error", "An error occurred, Please try again later!", "error");
      return false;
    }
  };

  handleCalendarUpdateQuickEvent = async (eventId, startDate, endDate, title, description = "", allDay = true, showToAll = false, eventMeta = null, targetUserIds = [], tabName = "") => {
    const startMoment = moment(startDate);
    const endMoment = endDate ? moment(endDate) : moment(startDate);
    const timeFormat = allDay ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss";

    const eventPayload = {
      title,
      description,
      startDate: startMoment.format(timeFormat),
      endDate: endMoment.format(timeFormat),
      isAllDay: allDay ? 1 : 0,
      showToAll: showToAll ? 1 : 0,
      targetUserIds: targetUserIds,
      category: tabName === "meeting" ? "meeting" : undefined,
    };

    swal({
      title: "Updating...",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode ? createSwalLoaderNode() : undefined,
    });

    try {
      const response = await AuthApi.updateCalendarEvent(eventId, eventPayload, eventMeta || {});
      swal.close();

      if (response && response.status === true) {
        swal("Success", `"${title}" updated successfully!`, "success");
        this.dashboardCalendarRangeCache.clear();
        this.getDashboardCalendarEvents();
        return true;
      } else {
        const errorMsg = typeof response === "string" ? response : (response && response.message ? response.message : "An error occurred, Please try again later!");
        swal("Error", errorMsg, "error");
        return false;
      }
    } catch (error) {
      swal("Error", "An error occurred, Please try again later!", "error");
      return false;
    }
  };

  handleCalendarOpenEditItem = (eventId, eventMeta = {}) => {
    const editStrategy = String(eventMeta.updateStrategy || eventMeta.strategy || "").trim().toLowerCase();
    const navigationState = {
      redirectTo: "/dashboard",
      fromDashboardCalendar: true,
      rawEvent: eventMeta.rawEvent || null,
      updateStrategy: editStrategy,
      category: eventMeta.category || "",
      calendarEditMode: editStrategy === "calendar",
      calendarEventId: eventId,
    };

    if (!eventId || !editStrategy) {
      swal("Error", "This item cannot be edited right now.", "error");
      return;
    }

    if (editStrategy === "event") {
      this.props.history.push({ pathname: `/upcoming-event/edit/${eventId}`, state: navigationState });
      return;
    }

    if (editStrategy === "holiday") {
      this.props.history.push({ pathname: `/holiday-leaves/edit/${eventId}`, state: navigationState });
      return;
    }

    if (editStrategy === "upcoming" || editStrategy === "calendar") {
      this.props.history.push({ pathname: `/upcoming-event/edit/${eventId}`, state: navigationState });
      return;
    }
  };

  handleCalendarDeleteQuickEvent = async (eventId, title, eventMeta = {}) => {
    const confirmation = await swal({
      title: "Delete event?",
      text: `Are you sure you want to delete "${title}"?`,
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!confirmation) {
      return;
    }

    swal({
      title: "Deleting...",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode ? createSwalLoaderNode() : undefined,
    });

    try {
      let response;
      const deleteStrategy = String(eventMeta.deleteStrategy || eventMeta.category || "").toLowerCase();
      const rawEvent = eventMeta.rawEvent || {};

      if (deleteStrategy === "leave") {
        response = await AuthApi.deleteLeaveTicket(eventId);
      } else if (deleteStrategy === "holiday") {
        response = await AuthApi.leaveDelete(eventId);
      } else if (deleteStrategy === "event" || deleteStrategy === "upcoming") {
        const deleteFn = AuthApi.deleteUpcomingEvent || AuthApi.AlleventDelete;
        response = await deleteFn.call(AuthApi, eventId);
        // Fallback: If upcoming event delete returns 404 or false, try calendar event delete
        if (!response || response.status !== true) {
          const fallbackResponse = await AuthApi.deleteCalendarEvent(eventId, eventMeta);
          if (fallbackResponse && fallbackResponse.status === true) {
            response = fallbackResponse;
          }
        }
      } else if (deleteStrategy === "calendar") {
        response = await AuthApi.deleteCalendarEvent(eventId, eventMeta);
        // Fallback: If calendar event delete returns 404 or false, try upcoming event delete
        if (!response || response.status !== true) {
          const deleteFn = AuthApi.deleteUpcomingEvent || AuthApi.AlleventDelete;
          const fallbackResponse = await deleteFn.call(AuthApi, eventId);
          if (fallbackResponse && fallbackResponse.status === true) {
            response = fallbackResponse;
          }
        }
      } else {
        // Fallback for unspecified strategy: try AlleventDelete first, then deleteCalendarEvent
        const deleteFn = AuthApi.deleteUpcomingEvent || AuthApi.AlleventDelete;
        response = await deleteFn.call(AuthApi, eventId);
        if (!response || response.status !== true) {
          const fallbackResponse = await AuthApi.deleteCalendarEvent(eventId, eventMeta);
          if (fallbackResponse && fallbackResponse.status === true) {
            response = fallbackResponse;
          }
        }
      }
      swal.close();

      if (response && response.status === true) {
        // Clean up local persistence cache if present
        const storageKey = getDashboardCalendarEventStorageKey(rawEvent, eventId, eventMeta);
        const persistenceKey = getDashboardCalendarEventPersistenceKey(rawEvent, eventId, eventMeta);

        const currentCreated = getCreatedDashboardCalendarItems();
        const updatedCreated = currentCreated.filter((item) => {
          return (
            getDashboardCalendarEventStorageKey(item) !== storageKey &&
            getDashboardCalendarEventPersistenceKey(item) !== persistenceKey
          );
        });
        setCreatedDashboardCalendarItems(updatedCreated);

        const currentUpdated = getUpdatedDashboardCalendarItems();
        if (currentUpdated[persistenceKey]) {
          delete currentUpdated[persistenceKey];
          setUpdatedDashboardCalendarItems(currentUpdated);
        }

        swal("Success", `"${title}" deleted successfully!`, "success");
        this.dashboardCalendarRangeCache.clear();
        this.getDashboardCalendarEvents();
      } else {
        const errorMsg = typeof response === "string" ? response : (response && response.message ? response.message : "An error occurred, Please try again later!");
        swal("Error", errorMsg, "error");
      }
    } catch (error) {
      console.error("Error deleting calendar event:", error);
      swal("Error", "An error occurred, Please try again later!", "error");
    }
  };

  notificationForBday = async () => {
    const bday = await AuthApi.bdayNotification();
    if (bday && bday.status === true) {
      this.setState({
        people: bday.data,
      }, () => {
        if (this.dashboardCalendarRangeCache) {
          this.dashboardCalendarRangeCache.clear();
        }
        if (typeof this.getDashboardCalendarEvents === "function") {
          this.getDashboardCalendarEvents();
        }
      });
    }
  };

  fetchAllUsers = async () => {
    const userData = await AuthApi.getData();
    if (userData && userData.status === true) {
      const activeUsers = (userData.data || []).filter(u => u.user_logged === 1 || String(u.user_logged) === '1' || (u.status && String(u.status).toLowerCase() === 'active'));
      this.setState({ allUsers: activeUsers }, () => {
        if (this.dashboardCalendarRangeCache) {
          this.dashboardCalendarRangeCache.clear();
        }
        if (typeof this.getDashboardCalendarEvents === "function") {
          this.getDashboardCalendarEvents();
        }
      });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
    });
  };

  handleNext = () => {
    this.setState({
      activeStep: this.state.activeStep + 1,
    });
  };

  handleNext1 = () => {
    this.setState({
      activeStep1: this.state.activeStep1 + 1,
    });
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  handleBack1 = () => {
    this.setState({
      activeStep1: this.state.activeStep1 - 1,
    });
  };

  handleStepChange = (step) => {
    this.setState({
      activeStep: step,
    });
  };

  handleStepChange1 = (step) => {
    this.setState({
      activeStep1: step,
    });
  };

  handleClickOpen = () => {
    this.setState({
      alertIsOpen: true,
    });
  };

  handleClose = () => {
    this.setState({
      alertIsOpen: false,
      openEventModal: false,
      dialogShown: true,
    });
    localStorage.setItem("dialogShown", "true");
  };

  updateLeave = (ticketId, newStatus, reason) => {
    const user = ls("user");
    const userName = `${user.firstName} ${user.lastName}`;

    const ticketUpdateData = {
      leaveStatus: newStatus,
      c_reason: newStatus === "Cancelled" ? reason : "",
      cancel_reason: newStatus !== "Cancelled" ? reason : "",
      updated_by: userName,
    };

    this.setState({ loading: true });

    AuthApi.updateTicketLeaveStatus(ticketUpdateData, ticketId)
      .then((response) => {
        if (response && response.status === true) {
          swal("Success", "Ticket status updated successfully", "success");
        } else {
          swal("Error", "Failed to update ticket status", "error");
        }
      })
      .catch((error) => {
        console.error("Error updating ticket status:", error);
        swal("Error", "Failed to update ticket status", "error");
      })
      .finally(() => {
        this.setState({ loading: false, showLeaveDetailsPopup: false });
        swal.close();
        this.getPendingLeaves();
        if (this.dashboardCalendarRangeCache) {
          this.dashboardCalendarRangeCache.clear();
        }
        if (typeof this.getDashboardCalendarEvents === "function") {
          this.getDashboardCalendarEvents();
        }
      });

    const isApproved = newStatus === "Approved";
    const rejected = newStatus === "Declined";
    this.setState((prevState) => ({
      rejectedTickets: {
        ...prevState.rejectedTickets,
        [ticketId]: rejected ? reason : "",
      },
      approvedTickets: {
        ...prevState.approvedTickets,
        [ticketId]: isApproved,
      },
    }));
  };

  handleLeaveClick = (leave) => {
    this.setState({
      selectedLeaveDetails: leave,
      showLeaveDetailsPopup: true,
      isReasonExpanded: false,
    });
  };

  handleCloseLeaveDetailsPopup = () => {
    this.setState({
      showLeaveDetailsPopup: false,
      selectedLeaveDetails: null,
    });
  };

  handleMonthChange = (event) => {
    this.setState({ selectedMonth: event.target.value });
  };

  handleYearChange = (event) => {
    this.setState({ selectedYear: event.target.value });
  };

  handleApproveLeave = (leaveId) => {
    swal({
      title: "Are you sure?",
      text: "Do you want to approve this leave?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willApprove) => {
      if (willApprove) {
        swal({
          title: "Processing...",
          text: "Please wait while we process your request.",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: {
            element: "div",
            attributes: {
              innerHTML: '<div class="swal-loading"><i class="fa fa-spinner fa-spin"></i></div>',
            },
          },
        });
        this.updateLeave(leaveId, "Approved", "");
      }
    });
  };

  handleDeclineLeave = (leaveId) => {
    swal({
      title: "Enter Reason",
      text: "Please enter the reason for declining the leave:",
      className: "leave-reason-swal",
      content: {
        element: "input",
        attributes: {
          placeholder: "Type your reason here",
          type: "text",
        },
      },
      buttons: {
        cancel: true,
        confirm: {
          text: "OK",
          closeModal: false,
        },
      },
    }).then((inputReason) => {
      if (!inputReason) {
        swal("Cancelled", "You need to write a reason!", "error");
        return;
      }
      swal({
        title: "Processing...",
        text: "Please wait while we process your request.",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: {
          element: "div",
          attributes: {
            innerHTML: '<div class="swal-loading"><i class="fa fa-spinner fa-spin"></i></div>',
          },
        },
      });
      this.updateLeave(leaveId, "Declined", inputReason);
    });
  };

  handleUpdateLeaveStatusFromCalendar = (leaveId, newStatus, reason = "") => {
    if (newStatus === "Approved") {
      this.handleApproveLeave(leaveId);
    } else if (newStatus === "Declined") {
      this.handleDeclineLeave(leaveId);
    } else if (newStatus === "Unapproved") {
      swal({
        title: "Are you sure?",
        text: "Do you want to mark this leave as unapproved?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willUnapprove) => {
        if (willUnapprove) {
          swal({
            title: "Processing...",
            text: "Please wait while we process your request.",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            content: {
              element: "div",
              attributes: {
                innerHTML: '<div class="swal-loading"><i class="fa fa-spinner fa-spin"></i></div>',
              },
            },
          });
          this.updateLeave(leaveId, "Unapproved", reason);
        }
      });
    } else if (newStatus === "Cancelled") {
      swal({
        title: "Enter Reason",
        text: "Please enter the reason for cancelling the leave:",
        className: "leave-reason-swal",
        content: {
          element: "input",
          attributes: {
            placeholder: "Type your reason here",
            type: "text",
          },
        },
        buttons: {
          cancel: true,
          confirm: {
            text: "OK",
            closeModal: false,
          },
        },
      }).then((inputReason) => {
        if (!inputReason) {
          swal("Cancelled", "You need to write a reason!", "error");
          return;
        }
        swal({
          title: "Processing...",
          text: "Please wait while we process your request.",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: {
            element: "div",
            attributes: {
              innerHTML: '<div class="swal-loading"><i class="fa fa-spinner fa-spin"></i></div>',
            },
          },
        });
        this.updateLeave(leaveId, "Cancelled", inputReason);
      });
    }
  };

  handleTimeEntryClick = (entry) => {
    sessionStorage.setItem('fromDashboard', 'true');
    this.props.history.push({
      pathname: "/time-entries",
      state: { timeEntryDetails: entry },
    });
  };

  async getPendingLeaves() {
    const isAdmin = ls("roles") === "Super Admin";
    const isEmployeeRole = ls("roles") === "Employee";
    let pendingLeaves = [];
    let approvedLeaves = [];
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();

    const filterCurrentMonthLeaves = (leaves) => {
      return leaves.filter((leave) => {
        const [startDate] = leave.date_range.split(" To ");
        const [, month, year] = startDate.split("-").map(Number);
        return month === currentMonth && year === currentYear;
      });
    };

    if (isAdmin) {
      const leavesData = await AuthApi.getTickets1();
      if (leavesData && leavesData.status === true) {
        pendingLeaves = leavesData.data.filter(
          (leave) => leave.status === "Pending"
        );
      }
    } else if (isEmployeeRole) {
      const empLeavesData = await AuthApi.getEmpLeaveticket();
      if (empLeavesData && empLeavesData.status === true) {
        pendingLeaves = empLeavesData.data.filter(
          (leave) => leave.status === "Pending"
        );
        approvedLeaves = filterCurrentMonthLeaves(
          empLeavesData.data.filter((leave) => leave.status === "Approved")
        );
      }
    }
    this.setState({ pendingLeaves, approvedLeaves });
  }

  async getUpcomingHolidays() {
    const holidaysData = await AuthApi.getLeaves();
    if (holidaysData && holidaysData.status === true) {
      const today = moment().startOf("day");
      const financialYearStartYear = today.month() >= 3 ? today.year() : today.year() - 1;
      const financialYearStart = moment(`${financialYearStartYear}-04-01`, "YYYY-MM-DD").startOf("day");
      const financialYearEnd = moment(`${financialYearStartYear + 1}-03-31`, "YYYY-MM-DD").endOf("day");

      const upcomingHolidays = holidaysData.data
        .filter((holiday) => {
          const holidayDate = moment(holiday.date, HOLIDAY_DATE_FORMATS, true);
          return (
            holidayDate.isValid() &&
            holidayDate.isBetween(financialYearStart, financialYearEnd, "day", "[]") &&
            holidayDate.isSameOrAfter(today, "day")
          );
        }).sort((a, b) => {
          const dateA = moment(a.date, HOLIDAY_DATE_FORMATS, true);
          const dateB = moment(b.date, HOLIDAY_DATE_FORMATS, true);
          return dateA.diff(dateB);
        });
      this.setState({ upcomingHolidays });
    }
  }



  async userleave1() {
    const userleave1 = await AuthApi.userleave();
    if (userleave1 && userleave1.status === true) {
      const userleave3 = userleave1.data;
      this.setState({ userleave: userleave3 });
    }
  }



  toggleDescription = () => {
    this.setState((prevState) => ({
      showFullDescription: !prevState.showFullDescription,
    }));
  };

  async getTimeEntries() {
    const timeEntriesData = await AuthApi.chekUserData();

    if (timeEntriesData) {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const filteredEntries = timeEntriesData.data.filter((entry) => {
        const [, month, year] = entry.date.split("-").map(Number);
        return month === currentMonth && year === currentYear;
      });
      this.setState(
        {
          timeEntries: { ...timeEntriesData, data: filteredEntries },
        }
      );
    }
  }

  async getUsersWithCurrentMonthDOJ() {
    const userData = await AuthApi.getData();
    if (userData && userData.status === true) {
      const currentMonth = new Date().getMonth() + 1;
      const currentDate = new Date().getDate();
      const currentYear = new Date().getFullYear();

      console.log('Current Date Info:', { currentMonth, currentDate, currentYear });

      const usersWithCurrentMonthDOJ = userData.data.filter((user) => {
        if (!user.doj) {
          console.log('User has no DOJ:', user.firstName);
          return false;
        }

        // Handle different date formats
        let month, year;
        if (user.doj.includes('-')) {
          const parts = user.doj.split('-');
          if (parts.length === 3) {
            // Check if format is DD-MM-YYYY or YYYY-MM-DD
            if (parts[0].length === 4) {
              // YYYY-MM-DD format
              year = Number(parts[0]);
              month = Number(parts[1]);
            } else {
              // DD-MM-YYYY format
              month = Number(parts[1]);
              year = Number(parts[2]);
            }
          } else {
            console.log('Invalid DOJ format:', user.doj, 'for user:', user.firstName);
            return false;
          }
        } else {
          console.log('DOJ does not contain dashes:', user.doj, 'for user:', user.firstName);
          return false;
        }

        console.log('User DOJ:', user.doj, 'Parsed:', { month, year, currentMonth }, 'User:', user.firstName);
        return month === currentMonth && year === currentYear;
      });

      console.log('Users with current month DOJ:', usersWithCurrentMonthDOJ.map(u => ({ name: u.firstName, doj: u.doj })));

      // Find all employees with today's DOJ
      const congratsEmployees = usersWithCurrentMonthDOJ.filter((user) => {
        if (!user.doj) return false;

        let day, month, year;
        if (user.doj.includes('-')) {
          const parts = user.doj.split('-');
          if (parts.length === 3) {
            if (parts[0].length === 4) {
              year = Number(parts[0]);
              month = Number(parts[1]);
              day = Number(parts[2]);
            } else {
              day = Number(parts[0]);
              month = Number(parts[1]);
              year = Number(parts[2]);
            }
          } else {
            return false;
          }
        } else {
          return false;
        }

        console.log('Checking congrats for user:', user.firstName, 'Day:', day, 'Current Date:', currentDate);
        return day === currentDate && month === currentMonth && year === currentYear;
      });

      console.log('Congrats Employees:', congratsEmployees.map(e => ({ name: e.firstName, doj: e.doj })));

      if (congratsEmployees.length > 0 && !this.state.congratsPopupShown) {
        console.log('Setting congrats employees:', congratsEmployees.map(e => e.firstName));
        this.setState({
          congratsEmployee: congratsEmployees[0],
          congratsEmployees: congratsEmployees,
          currentCongratsIndex: 0
        });
      } else if (congratsEmployees.length > 0 && this.state.congratsPopupShown) {
        console.log('Congrats employees found but popup already shown');
      } else {
        console.log('No congrats employees found for today');
      }

      this.setState({ usersWithCurrentMonthDOJ });
    } else {
      console.log('No user data available or API call failed');
    }
  }

  handleCongratsClose = () => {
    const { congratsEmployees, currentCongratsIndex } = this.state;

    if (congratsEmployees.length > currentCongratsIndex + 1) {
      this.setState({
        currentCongratsIndex: currentCongratsIndex + 1,
        congratsEmployee: congratsEmployees[currentCongratsIndex + 1]
      });
    } else {
      this.setState({
        congratsEmployee: null,
        congratsEmployees: [],
        currentCongratsIndex: 0,
        congratsPopupShown: true
      });
      localStorage.setItem("lastCongratsDate", new Date().toDateString());
    }
  };

  getStatusLabel = (isApproved) => {
    switch (isApproved) {
      case 0:
        return <span style={{ color: "green" }}>Approved</span>;
      case 1:
        return <span style={{ color: "orange" }}>Pending</span>;
      case 2:
        return <span style={{ color: "red" }}>Rejected</span>;
      default:
        return <span>Unknown</span>;
    }
  };

  handleMonthChange = (event) => {
    this.setState({ selectedMonth: event.target.value });
  };

  handleYearChange = (event) => {
    this.setState({ selectedYear: event.target.value });
  };

  render() {
    const { sections, pendingLeaves, approvedLeaves, upcomingHolidays, timeEntries, usersWithCurrentMonthDOJ, showLeaveDetailsPopup, selectedLeaveDetails, loading, dialogShown, people, getData, activeStep, activeStep1, show, openEventModal, eventDetails, congratsEmployee, showFullDescription, userleave, isReasonExpanded } = this.state;
    const { classes, theme, authUser } = this.props;
    const pendingLeavesHeader = "Pending Leaves";
    const currentRole = ls("roles");
    const isSuperAdmin = currentRole === "Super Admin";
    const isAdminCalendarUser = currentRole === "Super Admin" || currentRole === "Admin";
    const user = ls("user");
    const fs = user ? user.id : null;
    if (people.length && fs) {
      bdayID = people.some((data) => data.id === fs);
    }

    return (
      <div>
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={authUser}
          setAutUser={this.props.setAutUser}
          component={
            <div>
              {!dialogShown && bdayID && (
                <Dialog
                  open={show}
                  onClose={this.handleClose}
                  disableScrollLock={true}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  maxWidth={false}
                  PaperProps={{
                    style: {
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      overflow: 'visible'
                    },
                  }}
                >
                  <div className="Birthdatecard" style={{ overflow: "visible", display: 'flex', justifyContent: 'center' }}>
                    <LoginBirthdateCard handleClose={this.handleClose} />
                  </div>
                </Dialog>
              )}
              <div className="holiday-breadcrumb-card">
                <Breadcrumb
                  {...this.props}
                  primaryPageName="Dashboard"
                  primaryPageLink="/dashboard"
                  isSecondaryPage={false}
                  secondaryPageName=""
                />
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DashboardCalendar
                    events={this.state.dashboardCalendarEvents}
                    allUsers={this.state.allUsers}
                    isAdmin={isAdminCalendarUser}
                    loading={this.state.calendarLoading}
                    onApplyLeave={this.handleCalendarApplyLeave}
                    onRangeChange={this.getDashboardCalendarEvents}
                    onSaveQuickLeave={this.handleCalendarSaveQuickLeave}
                    onUpdateQuickEvent={this.handleCalendarUpdateQuickEvent}
                    onDeleteQuickEvent={this.handleCalendarDeleteQuickEvent}
                    onOpenEditItem={this.handleCalendarOpenEditItem}
                    onUpdateLeaveStatus={this.handleUpdateLeaveStatusFromCalendar}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Card style={{ marginBottom: 0, height: "100%" }}>
                    <CardContent style={{ paddingBottom: 0 }}>
                      <Tableforfilter props />
                    </CardContent>
                  </Card>
                </Grid>

                {isSuperAdmin && (
                  <Grid item xs={12}>
                    <EmployeePresenceMap />
                  </Grid>
                )}
              </Grid>

              {/* ── Reminder Popup Bell ─────────────────────────────── */}
              <ReminderPopup
                events={this.state.dashboardCalendarEvents}
                isAdmin={isAdminCalendarUser}
                currentUser={ls("user")}
              />

              <DragAndDropSections
                sections={sections}
                onDragEnd={this.onDragEnd}
                classes={classes}
                theme={theme}
                selectedMonth={this.state.selectedMonth}
                selectedYear={this.state.selectedYear}
                active={getData}
                activeStep={activeStep}
                handleStepChange={this.handleStepChange}
                handleNext={this.handleNext}
                permissions={authUser ? authUser.userAccess : []}
                handleBack={this.handleBack}
                maxStep={getData.length}
                active1={people}
                activeStep1={activeStep1}
                handleStepChange1={this.handleStepChange1}
                handleNext1={this.handleNext1}
                handleBack1={this.handleBack1}
                maxStep1={people.length}
                pendingLeaves={pendingLeaves}
                userleave={userleave}
                approvedLeaves={approvedLeaves}
                handleLeaveClick={this.handleLeaveClick}
                upcomingHolidays={upcomingHolidays}
                timeEntries={timeEntries}
                handleTimeEntryClick={this.handleTimeEntryClick}
                usersWithCurrentMonthDOJ={usersWithCurrentMonthDOJ}
                isSuperAdmin={isSuperAdmin}
                pendingLeavesHeader={pendingLeavesHeader}
                statusColors={this.state.statusColors}
              />

              {openEventModal && eventDetails && (
                <Dialog
                  open={openEventModal}
                  onClose={this.handleClose}
                  disableScrollLock={true}
                  maxWidth="xs"
                  fullWidth
                  PaperProps={{
                    style: {
                      // padding: "10px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      width: "500px",
                    },
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <DialogTitle
                      style={{
                        textAlign: "center",
                        padding: "5px 0",
                        backgroundColor: "var(--hrms-primary-blue-end)",
                        color: "#fff",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    >
                      Upcoming Event Details
                    </DialogTitle>
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        padding: "2px",
                      }}
                      onClick={this.handleClose}
                    />
                    <DialogContent>
                      <div>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Name</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{eventDetails.name}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Date</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{eventDetails.date}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Description</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <div>
                                  {showFullDescription || eventDetails.description.length <= 50
                                    ? eventDetails.description
                                    : `${eventDetails.description.substring(0, 50)}...`}
                                  {eventDetails.description.length > 50 && (
                                    <div>
                                      <Button onClick={this.toggleDescription} color="primary">
                                        {showFullDescription ? "Read less" : "Read more"}
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", }}><b>Image</b></td>
                              <td style={{ padding: "8px", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", }}>
                                <img src={eventDetails.image} alt={eventDetails.name} style={{ maxWidth: "200px", maxHeight: "111px" }} />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </DialogContent>
                  </div>
                </Dialog>
              )}
              {congratsEmployee && (
                <Dialog
                  open={!!congratsEmployee}
                  onClose={this.handleCongratsClose}
                  disableScrollLock={true}
                  aria-labelledby="congrats-dialog-title"
                  aria-describedby="congrats-dialog-description"
                  PaperProps={{
                    className: classes.congratsDialog,
                  }}
                >
                  <DialogTitle id="congrats-dialog-title" className={classes.congratsTitle}>
                    Congratulations!ðŸŽ‰
                    {this.state.congratsEmployees.length > 1 && (
                      <span style={{ fontSize: '0.8em', marginLeft: '10px' }}>
                        ({this.state.currentCongratsIndex + 1} of {this.state.congratsEmployees.length})
                      </span>
                    )}
                    <CloseIcon
                      className={classes.congratsCloseIcon}
                      onClick={this.handleCongratsClose}
                    />
                  </DialogTitle>
                  <DialogContent className={classes.congratsContent}>
                    <img
                      src={congratsEmployee.photo}
                      alt={congratsEmployee.firstName}
                      className={classes.congratsImage}
                    />
                    <Typography className={classes.congratsText}>
                      Congratulations To {congratsEmployee.firstName} {congratsEmployee.lastName} On Joining Us Today As A {congratsEmployee.designation}!
                    </Typography>
                    {this.state.congratsEmployees.length > 1 && (
                      <Typography variant="body2" style={{ marginTop: '10px', color: '#666' }}>
                        {this.state.currentCongratsIndex + 1 < this.state.congratsEmployees.length
                          ? 'Click to see next employee'
                          : 'Last employee - click to close'}
                      </Typography>
                    )}
                  </DialogContent>
                </Dialog>
              )}

              {showLeaveDetailsPopup && selectedLeaveDetails && (
                <Dialog
                  open={showLeaveDetailsPopup}
                  onClose={this.handleCloseLeaveDetailsPopup}
                  disableScrollLock={true}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: {
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      width: "600px",
                      minHeight: "370px"
                    },
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <DialogTitle
                      style={{
                        textAlign: "center",
                        padding: "5px 0",
                        background: "linear-gradient(180deg, #1f78dd 0%, #1b6fd1 100%)",
                        color: "#fff",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    >
                      Leave Details
                    </DialogTitle>
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        padding: "2px",
                      }}
                      onClick={this.handleCloseLeaveDetailsPopup}
                    />
                    <DialogContent>
                      <div>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Name</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedLeaveDetails.firstName}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Leave Type</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedLeaveDetails.leaveType}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Created On</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedLeaveDetails.created_at}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Leave</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                                {selectedLeaveDetails.ticket_mesasge ? (
                                  <>
                                    {isReasonExpanded || selectedLeaveDetails.ticket_mesasge.length <= 50
                                      ? selectedLeaveDetails.ticket_mesasge
                                      : `${selectedLeaveDetails.ticket_mesasge.substring(0, 50)}...`}
                                    {selectedLeaveDetails.ticket_mesasge.length > 50 && (
                                      <span
                                        onClick={() => this.setState({ isReasonExpanded: !isReasonExpanded })}
                                        style={{ color: '#1b6e95', cursor: 'pointer', marginLeft: '5px', display: 'inline-block' }}
                                      >
                                        {isReasonExpanded ? 'Read Less' : 'Read More'}
                                      </span>
                                    )}
                                  </>
                                ) : 'N/A'}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Date Range</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", whiteSpace: "nowrep" }}>
                                {(() => {
                                  const dateRange = this.state.selectedLeaveDetails.date_range;
                                  let startDate, endDate;

                                  if (dateRange.includes(' to ')) {
                                    [startDate, endDate] = dateRange.split(' to ');
                                  } else {
                                    [startDate, endDate] = dateRange.split(' To ');
                                  }

                                  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                                  return `${startDate} (${capitalize(this.state.selectedLeaveDetails.firstleavetype)}) To ${endDate} (${capitalize(this.state.selectedLeaveDetails.secondleavetype)})`;
                                })()}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>No Of Days</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedLeaveDetails.no_of_days}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", }}><b>Status</b></td>
                              <td style={{ padding: "8px", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", }}>{selectedLeaveDetails.status}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {isSuperAdmin && selectedLeaveDetails.status === "Pending" && (
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", marginBottom: "10px" }}>
                          <Button
                            className="common-action-button"
                            variant="contained"
                            onClick={() => { this.handleApproveLeave(selectedLeaveDetails.id); this.setState({ showLeaveDetailsPopup: false }); }}
                            style={{ 
                              margin: "5px", 
                              textTransform: "none", 
                              background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)", 
                              color: "white", 
                              borderRadius: "8px", 
                              fontWeight: 600,
                              fontStyle: "italic"
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() => { this.handleDeclineLeave(selectedLeaveDetails.id); this.setState({ showLeaveDetailsPopup: false }); }}
                            style={{ 
                              margin: "5px", 
                              textTransform: "none", 
                              backgroundColor: "#dc3545", 
                              color: "#ffffff", 
                              borderRadius: "8px", 
                              fontWeight: 600,
                              fontStyle: "italic"
                            }}
                          >
                            Declined
                          </Button>
                        </div>
                      )}
                      {loading && (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                          <CircularProgress />
                        </div>
                      )}
                    </DialogContent>
                  </div>
                </Dialog>
              )}
            </div>
          }
        />
        < Footer />
      </div >
    );
  }
}

export default withRouter(withTheme(withStyles(styles)(Dashboard)));






